import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBergingLeegmaken = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M20 25 8 29l12 4 12-4z"
    />
    <path
      fill="#B3E9B1"
      d="M8 17v12l12 4V21z"
    />
    <path
      fill="#60D15D"
      d="M32 17v12l-12 4V21z"
    />
    <path
      fill="#B3E9B1"
      d="m32 17-12 4v-8z"
    />
    <path
      fill="#60D15D"
      d="m8 17 12 4v-8z"
    />
    <path
      fill="#60D15D"
      d="m16 7 4 6-11.99 4.03L4 11z"
    />
    <path
      fill="#B3E9B1"
      d="m24 7-4 6 11.99 4.03L36 11z"
    />
    <path
      fill="#60D15D"
      d="m24 17-4 4 12-4 4-4z"
    />
    <path
      fill="#B3E9B1"
      d="m4 13 4 4 12 4-4-4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m8.8 26.396 6.35 2.14-.32.948-6.35-2.14zM9.128 24.226l3.62 1.21-.317.948-3.62-1.21z"
      clipRule="evenodd"
    />
    <path
      fill="#B3E9B1"
      d="m13 21.43 2 .67a.67.67 0 0 0 1-.64 1.44 1.44 0 0 0-1-1.27l-2-.68a.681.681 0 0 0-1 .65 1.46 1.46 0 0 0 1 1.27M30.84 25.02l-2.14-1.45-2.15 2.85 1.13-.37V29l2.04-.66v-2.95z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBergingLeegmaken);

export default ForwardRef;
